module.exports = __webpack_public_path__ + "static/media/romanian_infantry_120.79bf287f.png";